module.exports = __webpack_public_path__ + "img/enroll.c87248ca.png";